import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <circle cx={20} cy={20} r={20} fill="#DCE4EF" />
    <path
      stroke="#3752B3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.625}
      d="M27.219 18.688c0 4.629-5.358 8.748-6.625 9.657a1 1 0 0 1-.594.186 1 1 0 0 1-.594-.186c-1.267-.909-6.625-5.028-6.625-9.657a7.219 7.219 0 0 1 14.438 0"
    />
    <path
      stroke="#3752B3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.625}
      d="M17.375 18.031a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 0 0-5.25 0"
    />
  </svg>
);
export default SvgStreamlineLocation;
